import { S1CloudProviderData } from 'common/graphqlTypes';

export enum CLOUD_PROVIDER {
  AWS = 'AWS',
  AZURE = 'Azure',
  GCP = 'GCP',
  KUBERNETES = 'Kubernetes',
  ESXI = 'ESXI',
}
export interface CloudProviderConfiguration {
  image: string;
  title: string;
  // this flag indicates if cloud configuration section is not be supported.
  isSupported: boolean;
  fields: CloudProviderField[];
}

export interface CloudProviderField {
  title: string;
  key: keyof S1CloudProviderData;
  defaultValue: string;
}

export type CloudProviderConfigurations = { [key in CLOUD_PROVIDER]: CloudProviderConfiguration };
